<template>
  <div class="home_wrp page">
    <Hero />
    <HomeContent />
    <CTAView /> 
  </div>
</template>

<script>


import routerMenuMixin from "./mixins/routerMenuMixin";
import headers from "../models/headers";

import Hero from "../components/home/Hero.vue";
import HomeContent from "../components/home/HomeContent.vue";
import CTAView from "../components/home/CTAView.vue";



export default {
  mixins: [routerMenuMixin],
  components: {
    Hero,
    HomeContent,
    CTAView
  },
  metaInfo: headers.homePage(),

  methods: {
  },
  computed: {

  }
};

</script>
